// #ux-redesign-start: LegalLinksBar (Paso 5 — Auth redesign)
// Bar de links legales fija al pie del AuthLayout main. Reemplaza el
// LegalContent legacy (Card con Collapse hacia abajo).
//
// El click toggle la sección activa. La página padre decide dónde renderizar
// el contenido (en panel para desktop, en Modal para mobile).
//
// PORTABILIDAD: trasplantable a Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

const LegalLinksBar = ({ sections, activeId, onChange }) => (
  <nav className="ds-auth__legal-bar" aria-label="Legal information">
    <span className="ds-auth__legal-org">Alpha Research Deutschland GmbH</span>
    <ul className="ds-auth__legal-list">
      {sections.map((s, i) => (
        <li key={s.id}>
          <button
            type="button"
            className={`ds-auth__legal-link ${activeId === s.id ? 'is-active' : ''}`}
            onClick={() => onChange(activeId === s.id ? null : s.id)}
            aria-expanded={activeId === s.id}
          >
            {s.label}
          </button>
          {i < sections.length - 1 && (
            <span className="ds-auth__legal-sep" aria-hidden="true">·</span>
          )}
        </li>
      ))}
    </ul>
  </nav>
);

LegalLinksBar.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  activeId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default LegalLinksBar;
// #ux-redesign-end
